import { useTranslation } from 'react-i18next';
import { useClusters } from '../api/queries.js';
import ClusterCard from '../components/ClusterCard.js';

export default function Saved() {
  const { t } = useTranslation();
  const clusters = useClusters('saved');
  const items = clusters.data?.items ?? [];

  return (
    <div className="space-y-3 px-4 pb-4 pt-20">
      <h1 className="text-2xl font-bold">{t('saved.title')}</h1>
      {clusters.isLoading && (
        <p className="py-12 text-center text-neutral-500">{t('common.loading')}</p>
      )}
      {items.map((item) => (
        <ClusterCard key={item.id} item={item} />
      ))}
      {clusters.isSuccess && items.length === 0 && (
        <p className="py-16 text-center text-neutral-400">{t('saved.empty')}</p>
      )}
    </div>
  );
}
